import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import './home.scss';

// Home images
import logo from '../../assets/images/logo.png';
import diasparklogo from '../../assets/images/diaspark-logo.svg';
import homeimg from '../../assets/images/home-img.svg';
import buttonarrow from '../../assets/images/button-arrow.svg';

class HomeView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="home-header">
                    <Fade>
                        <Link to="/home">
                            <div className="header-left">
                                <img alt="logo" src={logo} />
                            </div>
                        </Link>
                    </Fade>
                    <div className="header-right right-logo">
                        <Fade>
                            <img alt="logo" src={diasparklogo} />
                        </Fade>
                    </div>
                </div>
                <div className="home-content">
                    <div className="homeleftcontent">
                        <Fade right>
                            <h4>Grow your business with CustomBuilt - The ultimate robust and scalable promotional  products software built from the ground  up for the promotional goods industry.</h4>
                        </Fade>
                        <Fade right><p>Take an interactive tour of CustomBuilt and schedule a demo to see it in action.</p></Fade>
                        <Fade right><Link to="/OrderEntry" className="theme-btn">Start your journey here <img alt="" src={buttonarrow} /></Link></Fade>
                    </div>
                    <div className="homerightcontent">
                        <Fade right>
                            <img alt="Custom Built" src={homeimg} />
                        </Fade>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default HomeView
